const exp = {
  exerciseCorrect: 15,
  exerciseIncorrect: 5,
  postVerified: 30,
  postLike: 10,
  practiceCorrectAnswer: 15,
}

export default exp;